// Lightweight i18n. Add keys here; UI calls t('key').
// Languages: ru (base), en, es, ar. Arabic triggers RTL layout.

export const RTL_LANGS = ['ar'];

export const LANGS = [
  { id:'ru', label:'Русский',  flag:'🇷🇺', code:'RU' },
  { id:'en', label:'English',  flag:'🇬🇧', code:'GB' },
  { id:'es', label:'Español',  flag:'🇪🇸', code:'ES' },
  { id:'ar', label:'العربية',  flag:'🇸🇦', code:'AR' },
  { id:'de', label:'Deutsch',  flag:'🇩🇪', code:'DE' },
];

import { ru } from './i18n.ru.js';

export const translations = { ru };
